export default function makeDistinct<T>(list: T[]): T[] {
    return Array.from(new Set(list));
}